// Case-insensitive, accent-insensitive, numeric-aware ("Queue 2" before "Queue 10") alphabetical order,
// used by the call queue / direct group / agent filter lists.
const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

export const compareText = (a: string | null | undefined, b: string | null | undefined): number =>
  collator.compare(a ?? "", b ?? "");

export const sortByLabel = <T extends { label: string }>(items: T[]): T[] =>
  [...items].sort((a, b) => compareText(a.label, b.label));

export const sortByName = <T extends { name: string }>(items: T[]): T[] =>
  [...items].sort((a, b) => compareText(a.name, b.name));
